module.exports = __webpack_public_path__ + "img/appDownloadNewBg.aca7e076.jpg";